import { render, staticRenderFns } from "./BaseSelectOption.vue?vue&type=template&id=4b722f12&"
import script from "./BaseSelectOption.vue?vue&type=script&lang=ts&"
export * from "./BaseSelectOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports